export default "__VITE_ASSET__nmkMs7qp__"